/**
 * --------------------------------------------------------------------------
 * Basic Modules: FullScreen.js
 * --------------------------------------------------------------------------
 */

"use strict";

/*
 * Constants
 */

const DEBUG             = true;
const NAME              = 'fullScreen';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    width: 1280,
    height: 1024,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
};

const Selector = {
    TOGGLE              : `[data-toggle-full-screen]`,
};

const DataAttr = {
    ACTIVE              : 'data-active',
    AILMENT_ID          : 'data-ailment-id',
};

class FullScreen {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, '::constructor() invoked');

        this.element = element;
        this.$element = $(this.element);
        this.config  = this.getConfig(config);

        this.addEventListeners();
        this.resize();
    }

    destroy() {
        this.$element.off(EVENT_KEY);
        this.$element.removeData(DATA_KEY);
        this.$element = null;
        this.element = null;
    }

    addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this.handleResize(event));
    }

    getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    resize() {
        let ratio = this.config.height / this.config.width;
        let viewportWidth = $(window).width();
        let viewportHeight = $(window).height();


        // Scale the image
        if ((viewportHeight / viewportWidth) > ratio) {
            this.$element.height(viewportHeight);
            this.$element.width(viewportHeight / ratio);
        }
        else {
            this.$element.width(viewportWidth);
            this.$element.height(viewportWidth * ratio);
        }

        // Center the image
        this.$element.css('left', (viewportWidth - this.$element.width()) / 2);
        this.$element.css('top', (viewportHeight - this.$element.height()) / 2);
    }

    handleResize(event) {
        this.resize();
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        FullScreen.jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new FullScreen(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME]             = FullScreen.jQueryInterface;
$.fn[NAME].Constructor = FullScreen;

export default FullScreen;
